import request from '@/utils/request';
const { VUE_APP_LAOSHIBANG } = process.env;

export function getCommonInfo(code) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/user/configs',
    method: 'post',
    data: { code }
  });
}

// 交流群小助手二维码
export function getQrcodeInfo() {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/qrcode/list',
    method: 'get',
    data: {}
  });
}
